import chlamydiaGonorrhea from 'images/kits/chlamydia-gonorrhea-box@2x.png';
import cholesterolLipids from 'images/kits/cholesterol-lipids-box@2x.png';
import bdVeritorTest from 'images/kits/DTC_Image_Cart_DBVeritor_COVIDTest.png';
import fitRectalCancer from 'images/kits/fit-colorectal-cancer-box@2x.png';
import hba1c from 'images/kits/hb-a-1-c-box@2x.png';
import heartHealth from 'images/kits/heart-health-box@2x.png';
import hepatitisC from 'images/kits/hepatitis-c-box@2x.png';
import hiv from 'images/kits/hiv-box@2x.png';
import hpv from 'images/kits/hpv-box@2x.png';
import metabolism from 'images/kits/metabolism-box@2x.png';
import syphilis from 'images/kits/syphilis-box@2x.png';
import testosterone from 'images/kits/testosterone-box@2x.png';
import thyroid from 'images/kits/thyroid-box@2x.png';
import trichomoniasis from 'images/kits/trichomoniasis-box@2x.png';
import vitaD from 'images/kits/v-itamin-d-box@2x.png';
import vitaDInflammation from 'images/kits/vitamin-d-inflammation-box@2x.png';

type MembershipProductSku = {
  title: string;
  originalPrice: string;
  pdpSlug: string;
  boxImage: string;
  category: string;
  additionalInfo: string;
  variantInfo: Record<string, number>;
};

export type MembershipCategoryProductSku = {
  label: string;
  items: Record<string, MembershipProductSku>;
};

export type MemberShipCategory = {
  [name: string]: MembershipCategoryProductSku;
};

export const categoryProductSKUMap: Record<string, MemberShipCategory> = {
  control: {
    'covid-19': {
      label: 'COVID-19',
      items: {
        'covid-bd-veritor-rapid': {
          title: 'BD Veritor At-Home COVID-19 Test',
          originalPrice: '$35',
          pdpSlug: 'covid-bd-veritor-rapid-test',
          boxImage: bdVeritorTest,
          category: 'Covid 19',
          additionalInfo: '',
          variantInfo: {
            'covid-bd-veritor-rapid-test': 1097,
          },
        },
      },
    },
    'energy-&-weight': {
      label: 'Energy & Weight Tests',
      items: {
        thyroid: {
          title: 'Thyroid Test',
          originalPrice: '$99',
          pdpSlug: 'thyroid-test',
          category: 'Energy & Weight',
          boxImage: thyroid,
          additionalInfo: '',
          variantInfo: {
            'thyroid-test': 512,
          },
        },
        metabolism: {
          title: 'Metabolism Test',
          originalPrice: '$49',
          pdpSlug: 'metabolism',
          category: 'Energy & Weight',
          boxImage: metabolism,
          additionalInfo: '',
          variantInfo: {
            metabolism: 513,
          },
        },
        testosterone: {
          title: 'Testosterone Test',
          originalPrice: '$49',
          pdpSlug: 'testosterone-test',
          category: 'Energy & Weight',
          boxImage: testosterone,
          additionalInfo: '',
          variantInfo: {
            'testosterone-test': 514,
          },
        },
        'vitamin-d': {
          title: 'Vitamin D Test',
          originalPrice: '$49',
          pdpSlug: 'vitamin-d-test',
          category: 'Energy & Weight',
          boxImage: vitaD,
          additionalInfo: '',
          variantInfo: {
            'vitamin-d-test': 515,
          },
        },
        'vitamin-d-and-inflammation': {
          title: 'Vitamin D & Inflammation Test',
          originalPrice: '$99',
          pdpSlug: 'vitamin-d-and-inflammation-test',
          category: 'Energy & Weight',
          boxImage: vitaDInflammation,
          additionalInfo: '',
          variantInfo: {
            'vitamin-d-and-inflammation-test': 516,
          },
        },
      },
    },
    'heart-health-&-screening': {
      label: 'Heart Health & Screening Tests',
      items: {
        hba1c: {
          title: 'HbA1c Test',
          originalPrice: '$49',
          pdpSlug: 'hba1c',
          boxImage: hba1c,
          category: 'Heart Health & Screening',
          additionalInfo: '',
          variantInfo: {
            hba1c: 510,
          },
        },
        'cholesterol-and-lipids': {
          title: 'Cholesterol & Lipids Test',
          originalPrice: '$49',
          pdpSlug: 'cholesterol-and-lipids-test',
          boxImage: cholesterolLipids,
          category: 'Heart Health & Screening',
          additionalInfo: '',
          variantInfo: {
            'cholesterol-and-lipids-test': 511,
          },
        },
        'fit-colon-cancer-screening': {
          title: 'FIT Colon Cancer Screening Test',
          originalPrice: '$49',
          pdpSlug: 'fit-colon-cancer-screening-test',
          boxImage: fitRectalCancer,
          category: 'Heart Health & Screening',
          additionalInfo: '',
          variantInfo: {
            'fit-colon-cancer-screening-test': 517,
          },
        },
        'hpv-test-female': {
          title: 'HPV Test - Female',
          originalPrice: '$49',
          pdpSlug: 'hpv-test-female',
          boxImage: hpv,
          category: 'Heart Health & Screening',
          additionalInfo: '',
          variantInfo: {
            'hpv-test-female': 518,
          },
        },
        'heart-health': {
          title: 'Heart Health Test',
          originalPrice: '$99',
          pdpSlug: 'heart-health-test',
          category: 'Heart Health & Screening',
          boxImage: heartHealth,
          additionalInfo: '',
          variantInfo: {
            'heart-health-test': 1071,
          },
        },
      },
    },
    'sexual-health': {
      label: 'Sexual Health Tests',
      items: {
        'chlamydia-and-gonorrhea': {
          title: 'Chlamydia & Gonorrhea Test',
          originalPrice: '$49',
          pdpSlug: 'chlamydia-gonorrhea-test',
          boxImage: chlamydiaGonorrhea,
          category: 'Sexual Health',
          additionalInfo: '',
          variantInfo: {
            'chlamydia-gonorrhea-test': 505,
          },
        },
        syphillis: {
          title: 'Syphilis Test',
          originalPrice: '$49',
          pdpSlug: 'syphilis-test',
          boxImage: syphilis,
          category: 'Sexual Health',
          additionalInfo: '',
          variantInfo: {
            'syphilis-test': 506,
          },
        },
        'hepatitis-c': {
          title: 'Hepatitis C Test',
          originalPrice: '$49',
          pdpSlug: 'hepatitis-c-test',
          boxImage: hepatitisC,
          category: 'Sexual Health',
          additionalInfo: '',
          variantInfo: {
            'hepatitis-c-test': 507,
          },
        },
        hiv: {
          title: 'HIV Test',
          originalPrice: '$49',
          pdpSlug: 'hiv-test',
          boxImage: hiv,
          category: 'Sexual Health',
          additionalInfo: '',
          variantInfo: {
            'hiv-test': 508,
          },
        },
        trichomoniasis: {
          title: 'Trichomoniasis Test',
          originalPrice: '$49',
          pdpSlug: 'trichomoniasis-test',
          boxImage: trichomoniasis,
          category: 'Sexual Health',
          additionalInfo: '',
          variantInfo: {
            'trichomoniasis-test': 509,
          },
        },
      },
    },
  },
  sti: {
    'sexual-health': {
      label: 'Sexual Health Tests',
      items: {
        'chlamydia-and-gonorrhea': {
          title: 'Chlamydia & Gonorrhea Test',
          originalPrice: '$49',
          pdpSlug: 'chlamydia-gonorrhea-test',
          boxImage: chlamydiaGonorrhea,
          category: 'Sexual Health',
          additionalInfo: '',
          variantInfo: {
            'chlamydia-gonorrhea-test': 375,
          },
        },
        syphillis: {
          title: 'Syphilis Test',
          originalPrice: '$49',
          pdpSlug: 'syphilis-test',
          boxImage: syphilis,
          category: 'Sexual Health',
          additionalInfo: '',
          variantInfo: {
            'syphilis-test': 376,
          },
        },
        'hepatitis-c': {
          title: 'Hepatitis C Test',
          originalPrice: '$49',
          pdpSlug: 'hepatitis-c-test',
          boxImage: hepatitisC,
          category: 'Sexual Health',
          additionalInfo: '',
          variantInfo: {
            'hepatitis-c-test': 377,
          },
        },
        hiv: {
          title: 'HIV Test',
          originalPrice: '$49',
          pdpSlug: 'hiv-test',
          boxImage: hiv,
          category: 'Sexual Health',
          additionalInfo: '',
          variantInfo: {
            'hiv-test': 378,
          },
        },
        trichomoniasis: {
          title: 'Trichomoniasis Test',
          originalPrice: '$49',
          pdpSlug: 'trichomoniasis-test',
          boxImage: trichomoniasis,
          category: 'Sexual Health',
          additionalInfo: '',
          variantInfo: {
            'trichomoniasis-test': 379,
          },
        },
      },
    },
  },
};
